import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import Assessment from "@/pages/Assessment";
import Report from "@/pages/Report";

function App() {
    return (
        <div className="App min-h-screen bg-white text-black">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/assessment" element={<Assessment />} />
                    <Route path="/report/:id" element={<Report />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
        </div>
    );
}

export default App;
